













import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import OwnerSelector from "@/componentsReusable/OwnerSelector.vue";

export default Vue.component('provider-owner', {
  name: 'ProviderOwner',
  props: {
    providerId: {
      type: [String, Number]
    },
    ownerField: {
      type: String,
      default: "owner"
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loadingModalData: false,
      loadingProviderOwner: true,
      loadingProviderOwnerCandidates: false,
      providerOwner: 'na',
      providerOwnerCandidates: [],
      showDropdown: false
    }
  },
  components: {
    BallPulseLoader,
    OwnerSelector
  },
  mounted: function () {
    this.getProviderOwner();
  },
  methods: {
    getProviderOwner () {
      let providerId = (this as any).providerId;
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingProviderOwner = true;
      }, 300);
      HTTP.get(`/api/providers/${providerId}/${this.ownerField}`)
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingProviderOwner = false;
        if (!response.data || !response.data.data) {
          throw new Error(`Error retrieving provider's ${self.ownerField}.`);
        }
        self.providerOwner = response.data.data.fullName? response.data.data.fullName : 'na';
      })
      .catch(function (err) {
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingProviderOwner = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: `An error occurred fetching this provider's ${self.ownerField}.`
        });
      })
    },

    async updateOwner (ownerCandidate: any) {
      this.showDropdown = false;
      let providerId = (this as any).providerId;
      let oldOwner = this.providerOwner;
      this.providerOwner = ownerCandidate.fullName;
      try {
        const response = await HTTP.put(`/api/providers/${providerId}/${this.ownerField}`, { "newProviderOwnerId": ownerCandidate.id});
        if (!response.data.success) {
          this.providerOwner = oldOwner;
          throw new Error(`Error updating Provider's ${this.ownerField}.`);
        }
      } catch (err) {
        console.log(err);
        this.providerOwner = oldOwner;
        this.$notify({
          group: 'main',
          type: 'error',
          title: `Error Updating ${this.ownerField}`
        });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/provider/providerComponents/ProviderOwner.vue